module.exports = __webpack_public_path__ + "static/img/no-data.ccac3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ar/no-data.png
// module id = uaW6
// module chunks = 1